import { render, staticRenderFns } from "./Prouni.vue?vue&type=template&id=58498cab&scoped=true&lang=pug&"
import script from "./Prouni.vue?vue&type=script&lang=js&"
export * from "./Prouni.vue?vue&type=script&lang=js&"
import style0 from "./Prouni.styl?vue&type=style&index=0&id=58498cab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58498cab",
  null
  
)

export default component.exports